<script setup lang="ts">
import type {
  NewProductModification,
  NewProductTag,
} from '@/types/api/api-v4/product'
import { ProductParentType } from '@/types/components/product-card.types'

import ProductTag from '@/components/Product/ProductTags/ProductTag.vue'
import ProductTagDiscount from '@/components/Product/ProductTags/ProductTagDiscount.vue'

type Props = {
  type: ProductParentType
  currentModification: NewProductModification
  mainTags: NewProductTag[]
  additionalTags: NewProductTag[]
}

const props = defineProps<Props>()

const filteredTags = computed(() => {
  // По умолчанию отображаем основные теги
  const tags = [...props.mainTags]

  // Если это детальная страница товара или ДО товара, то отображаем основные и дополнительные теги
  if (props.type === ProductParentType.detail) {
    tags.push(...props.additionalTags)
  }

  return tags.filter(({ is_extra, hidden }) => !is_extra && !hidden)
})

const componentClasses = computed(() => {
  return ['product-tags', `product-tags--type-${props.type}`]
})
</script>

<template>
  <div :class="componentClasses">
    <slot name="prepend" />

    <product-tag-discount
      :current-modification="currentModification"
      :type="type"
    />

    <product-tag
      v-for="(tag, index) in filteredTags"
      :key="index"
      :color="tag.hover_color"
      :background-color="tag.hover_background_color"
      :type="type"
    >
      {{ tag.name }}
    </product-tag>

    <slot name="append" />
  </div>
</template>

<style lang="scss" scoped>
.product-tags {
  display: flex;
  gap: 4px;
}

.product-tags--type-card {
  min-height: 21px;
  padding: 8px;

  @include media('>=desktop-mini') {
    min-height: 40px;
    padding: 16px 16px 8px;
  }
}
</style>
